<template>
  <v-card flat>
    <v-card-title class="text-h6 font-weight-bold px-0">
      Vista de Consumo Promedio
    </v-card-title>

    <v-card-text class="px-0">
      <!-- BUSCADOR -->
      <div class="px-4 mb-4 d-flex align-center">
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar insumo..." single-line hide-details
          outlined dense clearable style="max-width: 400px" class="mr-4"></v-text-field>
        <!-- <v-btn @click="showModalAddConsumo = true"> Añadir productos</v-btn> -->
      </div>

      <div v-if="!loading">
        <!-- VISTA ESCRITORIO -->
        <v-data-table :headers="tableHeaders" :items="insumos" :search="search" :items-per-page="15" hide-default-footer
          disable-pagination class="elevation-1 d-none d-md-block" :footer-props="{
            'items-per-page-options': [10, 15, 30, 50, -1],
            'items-per-page-text': 'Insumos por página',
          }">
          <template v-for="dayHeader in dayHeaders" v-slot:[`header.${dayHeader.value}`]="{ header }">
            <div :key="'th-' + dayHeader.value" class="d-flex flex-column align-center justify-center py-1">
              <span>{{ header.text }}</span>
              <v-chip x-small color="green" text-color="white" v-if="header.isToday"
                class="font-weight-bold text-caption mt-1">Hoy
              </v-chip>
            </div>
          </template>

          <template v-slot:body.prepend>
            <!-- Eventos Fijos (se muestran si existe al menos uno) -->
            <tr v-if="eventsByDate.hasFixed" class="grey lighten-4 font-weight-bold">
              <td class="text-start py-2">Eventos Fijos</td>
              <td v-for="header in dayHeaders" :key="'fixed-' + header.value" :class="[
                'text-center py-2',
                header.isToday ? 'green lighten-5' : '',
              ]">
                <v-chip v-if="eventsByDate.fixed[header.value]" x-small color="info" text-color="white" style="
                    white-space: normal;
                    height: auto;
                    padding: 4px 6px;
                    font-size: 12px;
                    line-height: 1.2;
                    word-break: break-word;
                  " :title="eventsByDate.fixed[header.value]">
                  {{ eventsByDate.fixed[header.value] }}
                </v-chip>
                <span v-else class="text-caption grey--text">-</span>
              </td>
            </tr>

            <!-- Eventos Recurrentes (se muestran si existe al menos uno) -->
            <tr v-if="eventsByDate.hasRecurring" class="grey lighten-4 font-weight-bold">
              <td class="text-start py-2">Eventos Recurrentes</td>
              <td v-for="header in dayHeaders" :key="'recurring-' + header.value" :class="[
                'text-center py-2',
                header.isToday ? 'green lighten-5' : '',
              ]">
                <v-chip v-if="eventsByDate.recurring[header.value]" x-small color="error" text-color="white" style="
                    white-space: normal;
                    height: auto;
                    padding: 4px 6px;
                    font-size: 12px;
                    line-height: 1.2;
                    word-break: break-word;
                  " :title="eventsByDate.recurring[header.value]">
                  {{ eventsByDate.recurring[header.value] }}
                </v-chip>
                <span v-else class="text-caption grey--text">-</span>
              </td>
            </tr>
          </template>

          <template v-for="header in dayHeaders" v-slot:[`item.${header.value}`]="{ item }">
            <div :key="header.value" class="d-flex align-center justify-center py-2"
              style="height: 100%; min-height: 48px">
              <v-icon v-if="
                item.consumos[header.value] &&
                item.consumos[header.value].isMin
              " small color="red" class="mr-1">mdi-arrow-down</v-icon>
              <v-icon v-if="
                item.consumos[header.value] &&
                item.consumos[header.value].isMax
              " small color="green" class="mr-1">mdi-arrow-up</v-icon>
              <span class="text-body-2 font-weight-medium">
                {{
                  item.consumos[header.value]
                    ? item.consumos[header.value].cantidad
                    : "0"
                }}
              </span>
            </div>
          </template>
        </v-data-table>

        <!-- VISTA MÓVIL -->
        <div class="d-block d-md-none px-4">
          <v-data-iterator :items="insumos" :search="search" :page.sync="mobilePage"
            :items-per-page="mobileItemsPerPage" hide-default-footer @page-count="mobilePageCount = $event">
            <template v-slot:default="{ items }">
              <v-card v-for="item in items" :key="item.nombre" class="mb-4 elevation-2 rounded-lg">
                <v-card-title class="d-flex align-center grey lighten-4 py-2">
                  <div class="text-h6 blue--text text--darken-4 text-truncate" style="max-width: calc(100% - 70px)">
                    {{ item.nombre }}
                  </div>
                  <v-spacer></v-spacer>
                </v-card-title>

                <v-card-text class="pa-0">
                  <template v-for="(header, index) in dayHeaders">
                    <v-row :key="header.value" :class="[
                      'ma-0 pa-3 align-center',
                      header.isToday ? 'green lighten-5' : '',
                    ]">
                      <v-col cols="6" class="pa-0 d-flex flex-column">
                        <span class="text-caption black--text">
                          <v-chip x-small color="green" text-color="white" v-if="header.isToday"
                            class="font-weight-bold text-caption mt-n1">Hoy
                          </v-chip>
                          {{ header.text }}
                        </span>
                        <div class="d-flex align-center mt-1">
                          <v-icon v-if="
                            item.consumos[header.value] &&
                            item.consumos[header.value].isMin
                          " small color="red" class="mr-1">mdi-arrow-down</v-icon>
                          <v-icon v-if="
                            item.consumos[header.value] &&
                            item.consumos[header.value].isMax
                          " small color="green" class="mr-1">mdi-arrow-up</v-icon>
                          <span class="text-h6 font-weight-bold black--text">
                            {{
                              item.consumos[header.value]
                                ? item.consumos[header.value].cantidad
                                : "0"
                            }}
                          </span>
                        </div>
                      </v-col>
                      <v-col cols="6" class="pa-0 d-flex flex-column align-end justify-center">
                        <!-- Evento Fijo (azul) -->
                        <v-chip v-if="eventsByDate.fixed[header.value]" small color="info" text-color="white"
                          class="font-weight-bold mb-1" style="
                            white-space: normal;
                            height: auto;
                            padding: 4px 8px;
                            text-align: center;
                            font-size: 10px;
                          ">
                          {{ eventsByDate.fixed[header.value] }}
                        </v-chip>
                        <!-- Evento Recurrente (rojo) -->
                        <v-chip v-if="eventsByDate.recurring[header.value]" small color="error" text-color="white"
                          class="font-weight-bold" style="
                            white-space: normal;
                            height: auto;
                            padding: 4px 8px;
                            text-align: center;
                            font-size: 10px;
                          ">
                          {{ eventsByDate.recurring[header.value] }}
                        </v-chip>
                      </v-col>
                    </v-row>
                    <v-divider v-if="index < dayHeaders.length - 1" :key="'div-' + header.value"></v-divider>
                  </template>
                </v-card-text>
              </v-card>
            </template>
          </v-data-iterator>

          <!-- Paginación Móvil -->
          <v-pagination v-model="mobilePage" :length="mobilePageCount" :total-visible="5" class="mb-6"
            color="primary"></v-pagination>
        </div>
      </div>
      <div v-else>
        <v-skeleton-loader type="table"></v-skeleton-loader>
      </div>
    </v-card-text>

    <!-- <modal
      v-model="showModalAddConsumo"
      :showFooter="false"
      title="Agregar consumo"
      max-width="500"
    >
      <ConsumoPromedioForm :productosElegidos="consumoPromedio" />
    </modal> -->
  </v-card>
</template>

<script>
import moment from "moment";
// import modal from "../../MainComponents/modal.vue";
// import ConsumoPromedioForm from "./ConsumoPromedioForm.vue";

export default {
  name: "VistaConsumo",
  components: {
    // modal,
    // ConsumoPromedioForm,
  },
  data() {
    return {
      dayHeaders: [],
      eventos: [],
      search: "",
      mobilePage: 1,
      mobilePageCount: 1,
      mobileItemsPerPage: 10,
      showModalAddConsumo: false,
      consumoPromedio: [],
      loading: false,
    };
  },
  watch: {
    search() {
      this.mobilePage = 1;
    },
  },
  computed: {
    tableHeaders() {
      return [
        { text: "Producto", value: "nombre", align: "start", sortable: false },
        ...this.dayHeaders.map((h) => ({
          ...h,
          class: h.isToday ? "green lighten-5" : "",
          cellClass: h.isToday ? "green lighten-5" : "",
        })),
      ];
    },
    // Mapea y separa los eventos en fijos ('F') y recurrentes ('R')
    eventsByDate() {
      const fixed = {};
      const recurring = {};
      let hasFixed = false;
      let hasRecurring = false;

      this.dayHeaders.forEach((header) => {
        const dateStr = header.value;

        // Filtrar eventos fijos (tipo 'F')
        const fixedEvents = this.eventos.filter((event) => {
          const vr = Array.isArray(event.vr)
            ? event.vr
            : event.vr
              ? [event.vr]
              : [];
          return event.tr === "F" && vr.includes(dateStr);
        });
        fixed[dateStr] = fixedEvents.length
          ? fixedEvents.map((e) => e.nm).join(", ")
          : null;
        if (fixed[dateStr]) hasFixed = true;

        // Filtrar eventos recurrentes (tipo 'R')
        const recEvents = this.eventos.filter((event) => {
          const vr = Array.isArray(event.vr)
            ? event.vr
            : event.vr
              ? [event.vr]
              : [];
          return event.tr === "R" && vr.includes(String(header.dayIndex));
        });
        recurring[dateStr] = recEvents.length
          ? recEvents.map((e) => e.nm).join(", ")
          : null;
        if (recurring[dateStr]) hasRecurring = true;
      });

      return { fixed, recurring, hasFixed, hasRecurring };
    },
    // Formatea los productos y sus consumos diarios para mostrarlos en la tabla
    insumos() {
      if (!this.consumoPromedio || !this.consumoPromedio.length) return [];

      return this.consumoPromedio.map((producto) => {
        const consumos = {};
        this.dayHeaders.forEach((header) => {
          // Si el día es domingo (índice 0), se ajusta a 7
          const dayKey = header.dayIndex === 0 ? 7 : header.dayIndex;
          // Obtiene la cantidad de consumo diario y la redondea a 2 decimales
          const rawCantidad =
            producto.dy && producto.dy[dayKey] !== undefined
              ? Number(producto.dy[dayKey])
              : 0;
          const cantidad = rawCantidad.toFixed(2);
          const um = producto.um || "";
          consumos[header.value] = {
            cantidad: `${cantidad} ${um}`.trim(),
            rawCantidad,
            isMax: false,
            isMin: false,
          };
        });

        // Calcular min y max para los indicadores
        const values = Object.values(consumos).map((c) => c.rawCantidad);
        const maxVal = Math.max(...values);
        const minVal = Math.min(...values);

        if (maxVal > minVal) {
          Object.keys(consumos).forEach((key) => {
            if (consumos[key].rawCantidad === maxVal)
              consumos[key].isMax = true;
            if (consumos[key].rawCantidad === minVal)
              consumos[key].isMin = true;
          });
        }

        return {
          id: producto.id,
          nombre: producto.nm || "Producto sin nombre",
          consumos,
        };
      });
    },
  },
  methods: {
    async getConsumoPromedio() {
      this.loading = true;
      const appId = "-OvvlkTC0f5NMPeaq9Gp";

      try {
        const dbPath = `APP/Conf-Front/${appId}/pd`;

        const snapshot =
          await this.$store.getters.getFirebaseApp.database.queryBuilder(
            dbPath,
          );
        let productosConfig = snapshot.val() || [];

        let productIds = [];

        if (productosConfig && typeof productosConfig === "object") {
          if (!Array.isArray(productosConfig)) {
            // es un diccionario de Firebase donde las llaves son los IDs
            productIds = Object.keys(productosConfig);
          } else {
            // ya es un arreglo
            // Mapeamos para extraer el string directamente 
            // o la propiedad .id si dentro hay objetos complejos
            productIds = productosConfig.map((producto) =>
              producto && typeof producto === "object" ? producto.id : producto,
            );
          }
        }

        // Construcción del payload final
        const payload = {
          tenant: this.$store.getters.getFirebaseApp.tenant || "BOKA",
          hoy: new moment().format("YYYY-MM-DD"),
          dias: 45,
          productos: productIds,
        };

        const result = await this.$store.getters.getFirebaseApp.fba.call(
          "AYB-Reportes-reporteInsumosSemanales",
          payload,
          {
            "Pgs-Req-App": appId,
            "PGS-REQ-VERSION": "1",
          },
        );

        if (result && result.data && result.data.ok) {
          this.consumoPromedio = result.data.data;
        }
      } catch (error) {
        console.error("Error en la ejecución de getConsumoPromedio:", error);
      } finally {
        this.loading = false;
      }
    },
    generarDias() {
      const nombresDias = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miercoles",
        "Jueves",
        "Viernes",
        "Sabado",
      ];
      const headers = [];

      for (let i = 0; i < 7; i++) {
        const fechaActual = moment().add(i, "days");
        const indiceDia = fechaActual.day();

        headers.push({
          text: `${nombresDias[indiceDia]} ${fechaActual.date()}`,
          value: fechaActual.format("YYYY-MM-DD"),
          align: "center",
          sortable: false,
          dayIndex: indiceDia,
          isToday: i === 0,
        });
      }
      this.dayHeaders = headers;
    },
    async getEventos() {
      try {
        const firebaseApp = this.$store.getters.getFirebaseApp;
        if (!firebaseApp || !firebaseApp.firestore) return;
        const firestore = firebaseApp.firestore;
        const data = await firestore.queryBuilder("MKT_Eventos", [
          firestore.where("tn", "==", firebaseApp.tenant),
          firestore.where("da", "==", null),
        ]);
        if (data.empty) {
          this.eventos = [];
        } else {
          this.eventos = data.docs.map((doc) => ({
            Id: doc.ref.id,
            ...doc.data(),
          }));
        }
      } catch (error) {
        console.error("Error fetching eventos:", error);
      }
    },
  },
  created() {
    this.generarDias();
    this.getEventos();
    this.getConsumoPromedio();
  },
};
</script>
